import { PreviewStatementDatasetSource } from "../previewTypes";

export const CASH_FLOW_DATASET: PreviewStatementDatasetSource = {
    shape: "statement",
    accountHeader: "Account",
    percentHeader: "% of total",
    percentBase: 1680198.42,
    rows: [
        { id: "operating", label: "Operating Activities", kind: "section" },
        {
            id: "net-income",
            label: "Net Income",
            kind: "line",
            amount: -93671.58,
        },
        {
            id: "depreciation",
            label: "Depreciation and Amortization",
            kind: "line",
            amount: 120000,
        },
        {
            id: "working-capital",
            label: "Change in Working Capital",
            kind: "line",
            amount: -86130,
        },
        {
            id: "net-operating",
            label: "Net Cash from Operating Activities",
            kind: "total",
            amount: -59801.58,
            hasTopBorder: true,
        },
        { id: "investing", label: "Investing Activities", kind: "section" },
        {
            id: "equipment",
            label: "Purchase of Equipment",
            kind: "line",
            amount: -380000,
        },
        {
            id: "net-investing",
            label: "Net Cash from Investing Activities",
            kind: "total",
            amount: -380000,
            hasTopBorder: true,
        },
        { id: "financing", label: "Financing Activities", kind: "section" },
        {
            id: "contributions",
            label: "Owner Contributions",
            kind: "line",
            amount: 1550000,
        },
        {
            id: "dividends",
            label: "Dividends Paid",
            kind: "line",
            amount: 0,
            hasActivity: true,
        },
        {
            id: "loan-proceeds",
            label: "Loan Proceeds",
            kind: "line",
            amount: 0,
        },
        {
            id: "net-financing",
            label: "Net Cash from Financing Activities",
            kind: "total",
            amount: 1550000,
            hasTopBorder: true,
        },
        {
            id: "net-change",
            label: "Net Change in Cash",
            kind: "total",
            amount: 1110198.42,
            hasTopBorder: true,
        },
        {
            id: "beginning-cash",
            label: "Cash at Beginning of Period",
            kind: "line",
            amount: 570000,
        },
        {
            id: "ending-cash",
            label: "Cash at End of Period",
            kind: "total",
            amount: 1680198.42,
            hasTopBorder: true,
        },
    ],
};
